
import dialogCloseBtn from "../common/dialog-close-btn.vue";
export default {
  components: { dialogCloseBtn },
  props: {
    dialog: false,
    title: "",
    content: "",
    img: "",
    primaryBtnText: {
      required: false,
      default: "Proceed",
      type: String
    },
    primaryBtnColor: {
      required: false,
      default: "#FF6B28",
      type: String
    },
    secondaryBtnText: {
      required: false,
      default: "Back",
      type: String
    },
    secondaryBtnColor: {
      required: false,
      default: "black",
      type: String
    },
    loading: {
      required: false,
      default: false,
      type: Boolean
    }
  },
  computed: {},
  methods: {
    isPairedChannel(channel) {}
  }
};
